import { Box, Typography, Button } from '@mui/material';
import Radio from '@mui/material/Radio';
import images from '~/assets/images';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import TitleUser from '~/components/TitleUser';
import Section from './Section';
import classNames from 'classnames/bind';
import styles from './Banking.module.scss';

const cx = classNames.bind(styles);

const Banking = () => {
    return (
        <Box sx={{ paddingLeft: '10px' }}>
            <TitleUser title="Nạp tiền" />
            <Section title="Phương thức thanh toán">
                <FormControl>
                    <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        className={cx('form-radio')}
                    >
                        <FormControlLabel sx={{ marginRight: '200px' }} value="bank" control={<Radio />} label="Chuyển khoản ngân hàng" />
                        <FormControlLabel value="vnpay" control={<Radio />} label="VNpay" />
                    </RadioGroup>
                </FormControl>
            </Section>
            <TitleUser title="Thông tin chuyển khoản" />
            <Section title="Tên ngân hàng" copy="Sao chép">
                <Box sx={{ display: 'flex' }} alignItems="center">
                    <Typography className={cx('name')}>Ngân hàng Á Châu (ACB) Phòng giao dịch hàng xanh</Typography>
                </Box>
            </Section>
            <Section title="Số tài khoản" copy="Sao chép">
                <Box sx={{ display: 'flex' }} alignItems="center">
                    <Typography className={cx('name')}>231307869</Typography>
                </Box>
            </Section>
            <Section title="Chủ tài khoản" copy="Sao chép">
                <Box sx={{ display: 'flex' }} alignItems="center">
                    <Typography className={cx('name')}>Công ty TNHH Viện Social Life</Typography>
                </Box>
            </Section>
            <Section title="Nội dung chuyển khoản" copy="Sao chép">
                <Box sx={{ display: 'flex' }} alignItems="center">
                    <Typography className={cx('name')}>SC20230521442304182337</Typography>
                </Box>
            </Section>
            <Typography className={cx('warning')} sx={{ fontSize: '13px' }}><GppMaybeIcon /> Lưu ý</Typography>
            <Typography sx={{ fontSize: '13px' }}>Xin vui lòng chuyển khoản theo đúng số tài khoản và nội dung hiển thị bên trên, để biết thêm thông tin vui lòng liên hệ đến hotline của chúng tôi</Typography>
            <Button variant="contained" className={cx('pay-success')}>Đã chuyển khoản</Button>
        </Box>
    );
};

export default Banking;
